import { chat as chatService } from '@shared/api/services';

export const chatSearchApi = {
  search: (query) => chatService.searchChats(query),
};
